import { useIsMobile } from "@elit-hair/elit-ui";
import { createFileRoute } from "@tanstack/react-router";
import { DateTime } from "luxon";
import { useMemo, useState } from "react";

import { ElitCalendar } from "@/components/calendar";
import { CalendarPlanBlock, CalendarView } from "@/types/calendar.types";
import { APP_ROUTES_FULL, APP_ROUTES_TO } from "@/utils/routes";

export const Route = createFileRoute(APP_ROUTES_FULL.EVENT_RULE)({
    component: ManagementCalendarPlan,
    staticData: {
        config: {
            breadcrumb: {
                title: "management_calendar_plan_details",
                to: APP_ROUTES_TO.EVENT_RULE,
            },
            title: "management_calendar_plan_details",
        },
    },
});

function ManagementCalendarPlan() {
    const isMobile = useIsMobile();
    const [view, setView] = useState<CalendarView>(isMobile ? "day" : "week");

    const transformedBlocks = useMemo<CalendarPlanBlock[]>(() => {
        // TODO this will be removed only used for demo purposes
        const tempBlocks: CalendarPlanBlock[] = [
            {
                id: 1,
                start: DateTime.now(),
                end: DateTime.now().plus({ minutes: 20 }),
                type: "SLOT",
                title: "Morning Slot",
                color: "blue",
                duration: 20,
                assignments: [],
            },
            {
                id: 2,
                start: DateTime.now(),
                end: DateTime.now().plus({ minutes: 20 }),
                type: "SLOT",
                title: "Lunch Break",
                color: "blue",
                duration: 20,
                assignments: [],
            },
        ];

        return tempBlocks;
    }, []);

    const onEventClick = (event: CalendarPlanBlock) => {
        const blockDetails = {
            start: event.start,
            end: event.end || "",
        };

        console.log("Event clicked:", event, blockDetails);
    };

    const onEventDelete = (event: CalendarPlanBlock) => {
        console.log("Event deleted:", event);
    };

    const onEventUpdate = (event: CalendarPlanBlock, newStartDate?: DateTime, newEndDate?: DateTime) => {
        console.log("Event updated:", event, newStartDate, newEndDate);
    };

    const onEventCreate = (startDate: DateTime, hour: number, minute: number) => {
        const newEventDate = startDate.set({ hour, minute, second: 0, millisecond: 0 });

        const blockDetails = {
            start: newEventDate,
            end: newEventDate.plus({ minutes: minute == 0 ? 20 : minute }),
        };

        console.log("Event created:", blockDetails);
    };

    return (
        <ElitCalendar
            view={view}
            blocks={transformedBlocks}
            onViewChange={setView}
            onEventClick={onEventClick}
            onEventDelete={onEventDelete}
            onEventUpdate={onEventUpdate}
            onEventCreate={onEventCreate}
        />
    );
}
